import type { Statemachine } from 'overmind';
import { statemachine } from 'overmind';

import * as identity from './effects/identity';

const effects = { identity };

type State = { current: 'NOT_READY' } | { current: 'READY' };

type Event = { type: 'RESET' } | { type: 'INITIALIZE' };

export type ArcGisAuthMachine = Statemachine<State, Event>;

const state = statemachine<State, Event>({
  NOT_READY: {
    INITIALIZE: () => ({ current: 'READY' })
  },
  READY: {
    RESET: () => ({ current: 'NOT_READY' })
  }
}).create({ current: 'NOT_READY' });

export { state, effects };
